import React from 'react'
import './EducationalImpact.scss'

const IconPerson = require('app_assets/images/icons/persona.png')
const IconGroup = require('app_assets/images/icons/grupos.png')
const IconPlace = require('app_assets/images/icons/lugar.png')

const EducationalImpact = () => {
  return (
    <div>
      <h2 className='education-impact--title'>Nuestra huella de formación</h2>
      <div className='education-impact--container'>
        <div className='education-impact--container-icon'>
          <img alt='Icono nuestra huella de formación personas' src={IconPerson}></img>
          <p>31.308 personas formadas durante el ultimo año</p>
        </div>
        <div className='education-impact--container-icon'>
          <img alt='Icono nuestra huella de formación grupos' src={IconGroup}></img>
          <p>954 grupos formados durante el ultimo año</p>
        </div>
        <div className='education-impact--container-icon'>
          <img alt='Icono nuestra huella de formación ubicación' src={IconPlace}></img>
          <p>390 Empresas formadas durante el ultimo año en Centroamérica y Sur América</p>
        </div>
      </div>
    </div>
  )
}

export default EducationalImpact
